import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";

const Ext = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="text-[#0066FF] hover:underline">
    {children}
  </a>
);

const LegalLayout = ({ title, eyebrow, children, testid }) => (
  <div className="App">
    <Navbar />
    <main className="bg-[#0A1628] min-h-screen">
      <section className="relative pt-32 pb-12 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628] via-[#0E1F38] to-[#0A1628]" />
        <div className="absolute -top-20 right-1/4 w-[500px] h-[500px] rounded-full bg-[#0066FF]/10 blur-[140px]" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white mb-6 text-sm" data-testid="back-to-home">
            <ChevronLeft className="w-4 h-4" /> Volver al inicio
          </Link>
          <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B00] font-semibold">
            {eyebrow}
          </span>
          <h1 className="mt-4 text-4xl md:text-5xl font-bold text-white leading-tight" style={{ fontFamily: "Poppins" }}>
            {title}
          </h1>
        </div>
      </section>

      <section className="pb-24">
        <div
          className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8"
          data-testid={testid}
        >
          <article className="bg-[#0F1E36] border border-white/10 rounded-3xl p-6 md:p-10 text-slate-300 leading-relaxed space-y-8 [&_h2]:text-white [&_h2]:font-semibold [&_h2]:text-xl [&_h2]:md:text-2xl [&_h2]:mt-2 [&_h2]:mb-3 [&_h2]:[font-family:Poppins] [&_p]:text-[15px] [&_strong]:text-white [&_ul]:space-y-2 [&_ul]:mt-2 [&_li]:relative [&_li]:pl-5 [&_li]:before:content-['·'] [&_li]:before:absolute [&_li]:before:left-0 [&_li]:before:text-[#0066FF] [&_li]:before:font-bold">
            {children}
          </article>
        </div>
      </section>
    </main>
    <Footer />
    <BackToTop />
  </div>
);

export const AvisoLegal = () => (
  <LegalLayout title="Aviso Legal" eyebrow="Información legal" testid="aviso-legal-content">
    <div>
      <h2>Titular del sitio web</h2>
      <ul>
        <li><strong>Denominación social:</strong> Oficina Técnica Agrícola La Mancha S.L.</li>
        <li><strong>CIF:</strong> B-13521570</li>
        <li><strong>Domicilio social:</strong> C/ Juan de la Cierva, 2 · 13600 Alcázar de San Juan (Ciudad Real)</li>
        <li><strong>Email:</strong> <a href="mailto:info@fiscalbond.es" className="text-[#0066FF] hover:underline">info@fiscalbond.es</a></li>
        <li><strong>Teléfonos:</strong> 926 032 626 / 633 089 026</li>
        <li><strong>Registro Mercantil:</strong> <span className="text-slate-400 italic">[completar cuando esté disponible]</span></li>
        <li><strong>Marca comercial:</strong> FiscalBond · Seguridad Fiscal Certificada</li>
        <li><strong>Número REDEF:</strong> <span className="text-[#FF6B00] font-mono">004VBSG6OC001684166</span> (concedido por la AEAT bajo RD 249/2023)</li>
      </ul>
    </div>

    <div>
      <h2>Objeto</h2>
      <p>
        Este sitio web (fiscalbond.es) tiene carácter informativo y comercial.
        FiscalBond ofrece servicios de gestión de extracciones de depósitos
        fiscales, representación fiscal ante la AEAT, intermediación en
        régimen suspensivo de impuestos especiales y asesoría en materia de
        impuestos especiales sobre alcohol, bebidas derivadas e hidrocarburos.
      </p>
    </div>

    <div>
      <h2>Propiedad intelectual</h2>
      <p>
        Los contenidos de este sitio web (textos, diseño, logotipos, imágenes
        y código) son propiedad de Oficina Técnica Agrícola La Mancha S.L. o
        de terceros que han autorizado su uso. Queda prohibida su
        reproducción, distribución o comunicación pública sin autorización
        expresa del titular.
      </p>
    </div>

    <div>
      <h2>Responsabilidad</h2>
      <p>
        FiscalBond no se responsabiliza de los daños derivados del uso de la
        información contenida en este sitio, ni de los posibles errores en
        los contenidos. Los enlaces a sitios externos (BOE, EUR-Lex, AEAT) se
        facilitan a título informativo; FiscalBond no controla ni se
        responsabiliza de su contenido.
      </p>
    </div>

    <div>
      <h2>Legislación aplicable</h2>
      <p>
        Este aviso legal se rige por la legislación española. Para cualquier
        controversia derivada del uso de este sitio web, las partes se
        someten a los Juzgados y Tribunales de Ciudad Real, con renuncia
        expresa a cualquier otro fuero.
      </p>
    </div>

    <div>
      <h2>Normativa de referencia</h2>
      <ul>
        <li><Ext href="https://www.boe.es/buscar/act.php?id=BOE-A-2002-13758">Ley 34/2002, de Servicios de la Sociedad de la Información (LSSI-CE)</Ext></li>
        <li><Ext href="https://eur-lex.europa.eu/legal-content/ES/TXT/?uri=CELEX%3A32016R0679">Reglamento (UE) 2016/679 (RGPD)</Ext></li>
        <li><Ext href="https://www.boe.es/buscar/act.php?id=BOE-A-2018-16673">Ley Orgánica 3/2018 (LOPDGDD)</Ext></li>
      </ul>
    </div>
  </LegalLayout>
);

export const PoliticaPrivacidad = () => (
  <LegalLayout title="Política de Privacidad" eyebrow="Protección de datos" testid="privacidad-content">
    <div>
      <h2>Responsable del tratamiento</h2>
      <ul>
        <li><strong>Oficina Técnica Agrícola La Mancha S.L.</strong> · CIF B-13521570</li>
        <li>C/ Juan de la Cierva, 2 · 13600 Alcázar de San Juan (Ciudad Real)</li>
        <li><a href="mailto:info@fiscalbond.es" className="text-[#0066FF] hover:underline">info@fiscalbond.es</a> · 926 032 626</li>
      </ul>
    </div>

    <div>
      <h2>Finalidades del tratamiento</h2>
      <p>
        Los datos personales recogidos a través del formulario de contacto y
        del newsletter se tratan para:
      </p>
      <ul>
        <li>Atender consultas y solicitudes de información sobre nuestros servicios</li>
        <li>Enviar comunicaciones comerciales sobre servicios de FiscalBond (solo si existe consentimiento expreso)</li>
        <li>Gestión de la relación comercial con clientes y proveedores</li>
      </ul>
    </div>

    <div>
      <h2>Base jurídica</h2>
      <ul>
        <li>Ejecución de un contrato o aplicación de medidas precontractuales (art. 6.1.b RGPD)</li>
        <li>Interés legítimo para el seguimiento de consultas (art. 6.1.f RGPD)</li>
        <li>Consentimiento expreso para comunicaciones comerciales (art. 6.1.a RGPD)</li>
      </ul>
    </div>

    <div>
      <h2>Conservación de datos</h2>
      <p>
        Los datos se conservan durante el tiempo necesario para atender la
        consulta y, en caso de relación contractual, durante el plazo de
        prescripción de las obligaciones legales aplicables (máximo 6 años
        según legislación mercantil y fiscal).
      </p>
    </div>

    <div>
      <h2>Destinatarios</h2>
      <p>
        No se ceden datos a terceros salvo obligación legal. Los datos pueden
        ser accedidos por proveedores de servicios tecnológicos (hosting,
        email) que actúan como encargados del tratamiento bajo contrato
        conforme al art. 28 RGPD.
      </p>
    </div>

    <div>
      <h2>Transferencias internacionales</h2>
      <p>
        No se realizan transferencias internacionales de datos fuera del
        Espacio Económico Europeo.
      </p>
    </div>

    <div>
      <h2>Derechos del interesado</h2>
      <p>
        Puedes ejercer tus derechos de acceso, rectificación, supresión,
        oposición, limitación y portabilidad enviando un email a{" "}
        <a href="mailto:info@fiscalbond.es" className="text-[#0066FF] hover:underline">info@fiscalbond.es</a>{" "}
        con asunto <strong>"Protección de Datos"</strong>, adjuntando copia
        de tu DNI o documento identificativo.
      </p>
    </div>

    <div>
      <h2>Reclamaciones</h2>
      <p>
        Si consideras que el tratamiento de tus datos no es conforme al RGPD,
        puedes presentar una reclamación ante la{" "}
        <Ext href="https://www.aepd.es">Agencia Española de Protección de Datos (www.aepd.es)</Ext>.
      </p>
    </div>

    <div>
      <h2>Normativa aplicable</h2>
      <ul>
        <li><Ext href="https://eur-lex.europa.eu/legal-content/ES/TXT/?uri=CELEX%3A32016R0679">Reglamento (UE) 2016/679 (RGPD)</Ext></li>
        <li><Ext href="https://www.boe.es/buscar/act.php?id=BOE-A-2018-16673">Ley Orgánica 3/2018 de Protección de Datos Personales (LOPDGDD)</Ext></li>
      </ul>
    </div>

    <p className="text-xs text-slate-500 pt-4 border-t border-white/10">
      Última actualización: mayo 2026
    </p>
  </LegalLayout>
);

export default LegalLayout;
